export default {
    CANONICAL: 0,
    REDIRECT_301: 1,
    REDIRECT_302: 2,
}